import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ErrorBoundary } from "../../components/ErrorBoundary";
import SystemDialog from "../../components/UIToolkit/Popups/Dialog";
import SystemButton from "../../components/UIToolkit/SystemButton/SystemButton";
import SelfSchedulingCalendar from "./SelfSchedulingCalendar";
import SelfSchedulingMetrics from "./SelfSchedulingMetrics";
import useSelfSchedulingState from "./state/useSelfSchedulingState";

const SelfSchedulingDemo = () => {
	const { t } = useTranslation();
	const {
		daysData,
		sundayIsFirstDayOfWeek,
		currentMetrics,
		metricsRef,
		unsavedChanges,
		isPublishWarningOpen,
		handleSaveClick,
		handleOnDayClick,
		togglePublishWarning,
		handlePerformPublish,
		rdoMaxAmount,
		signUpShiftsTargetAmount,
		weekendsTargetAmount,
	} = useSelfSchedulingState();

	return (
		<Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "start" }}>
			<ErrorBoundary>
				<SelfSchedulingMetrics
					ref={metricsRef}
					signupShiftsCurrentAmount={currentMetrics.signupShiftsCurrentAmount}
					weekendsCurrentAmount={currentMetrics.weekendsCurrentAmount}
					rdosCurrentAmount={currentMetrics.rdoCount}
					rdosMaxAmount={rdoMaxAmount}
					weekendsTargetAmount={weekendsTargetAmount}
					signupShiftsTargetAmount={signUpShiftsTargetAmount}
				/>
			</ErrorBoundary>
			<ErrorBoundary>
				<Box
					sx={{
						width: "100%",
						height: `calc(100% - ${metricsRef.current?.offsetHeight ?? 0}px)`,
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "space-between",
						overflow: "auto",
					}}
				>
					<Box
						sx={{
							mt: 3,
							width: "100%",
							height: "fit-content",
						}}
					>
						<SelfSchedulingCalendar sundayIsFirstDayOfWeek={sundayIsFirstDayOfWeek} daysData={daysData} onDayClick={handleOnDayClick} />
					</Box>
					<Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "start" }}>
						{unsavedChanges ? (
							<SystemButton onClick={handleSaveClick}>{t("update.preferences")}</SystemButton>
						) : (
							<SystemButton sx={{ mt: 1 }} onClick={togglePublishWarning}>
								{t("submit")}
							</SystemButton>
						)}
						<SystemDialog
							title={t("publish.preferences")}
							body={t("publish.preferences.confirm")}
							open={isPublishWarningOpen}
							onClose={togglePublishWarning}
							onConfirm={handlePerformPublish}
						/>
					</Box>
				</Box>
			</ErrorBoundary>
		</Box>
	);
};

export default SelfSchedulingDemo;
